/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NftTracker } from './NftTracker';
import {
    NftTrackerFromJSON,
    NftTrackerFromJSONTyped,
    NftTrackerToJSON,
    NftTrackerToJSONTyped,
} from './NftTracker';

/**
 * 
 * @export
 * @interface NftOwnershipWithWallet
 */
export interface NftOwnershipWithWallet {
    /**
     * 
     * @type {string}
     * @memberof NftOwnershipWithWallet
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof NftOwnershipWithWallet
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof NftOwnershipWithWallet
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof NftOwnershipWithWallet
     */
    nftGroupingId?: string;
    /**
     * 
     * @type {string}
     * @memberof NftOwnershipWithWallet
     */
    nftTrackerId: string;
    /**
     * 
     * @type {string}
     * @memberof NftOwnershipWithWallet
     */
    userId?: string;
    /**
     * 
     * @type {number}
     * @memberof NftOwnershipWithWallet
     */
    nftId: number;
    /**
     * 
     * @type {string}
     * @memberof NftOwnershipWithWallet
     */
    tokenUri?: string;
    /**
     * 
     * @type {string}
     * @memberof NftOwnershipWithWallet
     */
    tokenImageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof NftOwnershipWithWallet
     */
    nftGroupingIndex?: number;
    /**
     * 
     * @type {number}
     * @memberof NftOwnershipWithWallet
     */
    burnedAt?: number;
    /**
     * 
     * @type {number}
     * @memberof NftOwnershipWithWallet
     */
    redeemedAt?: number;
    /**
     * 
     * @type {string}
     * @memberof NftOwnershipWithWallet
     */
    redeemRecord?: string;
    /**
     * 
     * @type {number}
     * @memberof NftOwnershipWithWallet
     */
    replacedAt?: number;
    /**
     * 
     * @type {string}
     * @memberof NftOwnershipWithWallet
     */
    replacedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof NftOwnershipWithWallet
     */
    transactionHash?: string;
    /**
     * 
     * @type {number}
     * @memberof NftOwnershipWithWallet
     */
    nftTrackerIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof NftOwnershipWithWallet
     */
    notes?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NftOwnershipWithWallet
     */
    isVirtual?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NftOwnershipWithWallet
     */
    isEligibleForCompetitions?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NftOwnershipWithWallet
     */
    ofCurrentCommunity?: boolean;
    /**
     * The type of wallet holding this NFT (THIRDWEB, MAGIC, WALLET_CONNECT, etc.)
     * @type {string}
     * @memberof NftOwnershipWithWallet
     */
    walletType?: string;
    /**
     * The blockchain address of the wallet holding this NFT
     * @type {string}
     * @memberof NftOwnershipWithWallet
     */
    walletAddress?: string;
    /**
     * 
     * @type {NftTracker}
     * @memberof NftOwnershipWithWallet
     */
    tracker?: NftTracker;
}

/**
 * Check if a given object implements the NftOwnershipWithWallet interface.
 */
export function instanceOfNftOwnershipWithWallet(value: object): value is NftOwnershipWithWallet {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('nftTrackerId' in value) || value['nftTrackerId'] === undefined) return false;
    if (!('nftId' in value) || value['nftId'] === undefined) return false;
    return true;
}

export function NftOwnershipWithWalletFromJSON(json: any): NftOwnershipWithWallet {
    return NftOwnershipWithWalletFromJSONTyped(json, false);
}

export function NftOwnershipWithWalletFromJSONTyped(json: any, ignoreDiscriminator: boolean): NftOwnershipWithWallet {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'nftGroupingId': json['nftGroupingId'] == null ? undefined : json['nftGroupingId'],
        'nftTrackerId': json['nftTrackerId'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'nftId': json['nftId'],
        'tokenUri': json['tokenUri'] == null ? undefined : json['tokenUri'],
        'tokenImageUrl': json['tokenImageUrl'] == null ? undefined : json['tokenImageUrl'],
        'nftGroupingIndex': json['nftGroupingIndex'] == null ? undefined : json['nftGroupingIndex'],
        'burnedAt': json['burnedAt'] == null ? undefined : json['burnedAt'],
        'redeemedAt': json['redeemedAt'] == null ? undefined : json['redeemedAt'],
        'redeemRecord': json['redeemRecord'] == null ? undefined : json['redeemRecord'],
        'replacedAt': json['replacedAt'] == null ? undefined : json['replacedAt'],
        'replacedBy': json['replacedBy'] == null ? undefined : json['replacedBy'],
        'transactionHash': json['transactionHash'] == null ? undefined : json['transactionHash'],
        'nftTrackerIndex': json['nftTrackerIndex'] == null ? undefined : json['nftTrackerIndex'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'isVirtual': json['isVirtual'] == null ? undefined : json['isVirtual'],
        'isEligibleForCompetitions': json['isEligibleForCompetitions'] == null ? undefined : json['isEligibleForCompetitions'],
        'ofCurrentCommunity': json['ofCurrentCommunity'] == null ? undefined : json['ofCurrentCommunity'],
        'walletType': json['walletType'] == null ? undefined : json['walletType'],
        'walletAddress': json['walletAddress'] == null ? undefined : json['walletAddress'],
        'tracker': json['tracker'] == null ? undefined : NftTrackerFromJSON(json['tracker']),
    };
}

export function NftOwnershipWithWalletToJSON(json: any): NftOwnershipWithWallet {
    return NftOwnershipWithWalletToJSONTyped(json, false);
}

export function NftOwnershipWithWalletToJSONTyped(value?: NftOwnershipWithWallet | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'nftGroupingId': value['nftGroupingId'],
        'nftTrackerId': value['nftTrackerId'],
        'userId': value['userId'],
        'nftId': value['nftId'],
        'tokenUri': value['tokenUri'],
        'tokenImageUrl': value['tokenImageUrl'],
        'nftGroupingIndex': value['nftGroupingIndex'],
        'burnedAt': value['burnedAt'],
        'redeemedAt': value['redeemedAt'],
        'redeemRecord': value['redeemRecord'],
        'replacedAt': value['replacedAt'],
        'replacedBy': value['replacedBy'],
        'transactionHash': value['transactionHash'],
        'nftTrackerIndex': value['nftTrackerIndex'],
        'notes': value['notes'],
        'isVirtual': value['isVirtual'],
        'isEligibleForCompetitions': value['isEligibleForCompetitions'],
        'ofCurrentCommunity': value['ofCurrentCommunity'],
        'walletType': value['walletType'],
        'walletAddress': value['walletAddress'],
        'tracker': NftTrackerToJSON(value['tracker']),
    };
}

